import Dictionary from "~/ts/library/Dictionary";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import EventManager from "~/ts/library/EventManager";
import Delay from "~/ts/library/Delay";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import {toggleArrayElement} from "~/ts/library/ToggleArrayElement";
import {ComponentInstance, computed, ref} from "vue";
import {OPERATOR_APPLICATION_RELOAD_DATA_EVENT} from "~/operatorApplication/ts/service/comet/Constants";
import OperatorApplicationPlatform from "~/operatorApplication/ts/platform/OperatorApplicationPlatformFactory";
import {MESSAGE_STATUS_DELIVERED} from "~/core-ui/vue/chat/Constants";
import {
    MESSAGE_REMOVED,
    NEW_HAVE_NO_ANSWER_CLIENT,
    OPERATOR_STATUS_UPDATED,
    OperatorApplicationEventManager,
    OperatorStatusUpdatedEventPayload,
    READ_ALL_MESSAGES_OF_CLIENT,
    SCROLL_CHAT_TO_BOTTOM,
    UPDATE_ORDER
} from "~/operatorApplication/ts/OperatorApplicationEventManager";
import {
    OPERATOR_APPLICATION_NEW_CROSS_OPERATOR_MESSAGE,
    OPERATOR_APPLICATION_SOUND_NEW_DIALOG,
    OPERATOR_APPLICATION_SOUND_NEW_MESSAGE
} from "~/operatorApplication/ts/service/OperatorApplicationSoundPlayer";
import {
    APP_ICON_BADGE_TYPE_MESSAGES,
    OperatorApplicationConfigInstance
} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import ObjectHelper from "~/ts/library/ObjectHelper";
import CoreUiChatHistoryHelper from "~/core-ui/vue/chat/CoreUiChatHistoryHelper";
import OperatorApplicationClientOpenApiModel = OperatorApplicationApi.OperatorApplicationClientOpenApiModel;
import ClientMessageWithUnreadedStateOpenApiModel = OperatorApplicationApi.ClientMessageWithUnreadedStateOpenApiModel;
import OperatorApplicationClientAvatarOpenApiModel = OperatorApplicationApi.OperatorApplicationClientAvatarOpenApiModel;

let fetchEvents = new EventManager();


const FETCH_LIMIT = 1000;


class ClientUserdata {
    messagesDictionary = ref<Dictionary<OperatorApplicationApi.OperatorApplicationMessageOpenApiModel[]>>({});
    dialogsDictionary = ref<Dictionary<Dictionary<OperatorApplicationApi.OperatorApplicationClientCurrentDialogOpenApiModel>>>({});
    dialogsIds = ref<Dictionary<number[]>>({});

    public isLoading = ref(false);
    private isDelayBeforeFetch: boolean = true;

    markedAsUnreadedDictionary = ref<Dictionary<boolean>>({});
    public siteOfUsernames = ref<Dictionary<string>>({});
    public siteOfUsernamesNonReactive: Dictionary<string> = {};
    selectedUsernameInSelectedSection = ref<string>();
    private userdataDictionary = ref<Dictionary<CometOperatorApplication.OperatorApplicationClientOpenApiModel>>({});
    readonly unreadedApplicationBadge = computed(() => {
        let result = 0;
        let usernames: string[] = [];
        let badgeType = OperatorApplicationConfigInstance.appIconBadgeType;
        let hasCrossOperatorsChat = false;
        let hasClients = false;
        for (let buddyListId in this.unreadedCountByBuddyList.value) {
            if (this.unreadedCountByBuddyList.value.hasOwnProperty(buddyListId)) {
                let usernamesByBuddyList = this.unreadedCountByBuddyList.value[buddyListId];
                for (let username in usernamesByBuddyList) {
                    if (usernamesByBuddyList.hasOwnProperty(username)) {
                        if (usernames.indexOf(username) == -1) {
                            usernames.push(username);
                            let userdata = this.userdataDictionary.value[username];
                            if (userdata) {
                                if (CoreUiChatHistoryHelper.isOneOfCrossOperatorsChat(userdata)) {
                                    hasCrossOperatorsChat = true;
                                } else {
                                    hasClients = true;
                                }
                            }
                            if (usernamesByBuddyList[username]) {
                                if (badgeType == APP_ICON_BADGE_TYPE_MESSAGES) {
                                    result += usernamesByBuddyList[username];
                                } else {
                                    result++;
                                }
                            }
                        }
                    }
                }
            }
        }
        if (!hasCrossOperatorsChat || !result) {
            OPERATOR_APPLICATION_NEW_CROSS_OPERATOR_MESSAGE.stop();
        }
        if (!hasClients || !result) {
            OPERATOR_APPLICATION_SOUND_NEW_MESSAGE.stop();
            OPERATOR_APPLICATION_SOUND_NEW_DIALOG.stop();
        }
        return result;
    });
    readonly mainBuddyListUnreadedCount = computed<number>(() => {
        let result = 0;
        for (let username of OperatorAccountStore.buddyList.value) {
            if (this.userdataDictionary.value.hasOwnProperty(username)) {
                if (this.userdataDictionary.value[username] && this.userdataDictionary.value[username].unreadedMessageIds.length) {
                    result++;
                }
            }
        }
        return result ? result : null;
    });
    private subscribesByBuddyList = ref<Dictionary<string[]>>({});
    readonly unreadedCountByBuddyList = computed(() => {
        let result: Dictionary<Dictionary<number>> = {};
        for (let buddyList of OperatorAccountStore.data.value.buddyListConfig) {
            result[buddyList.id] = {};
            let usernames = this.subscribesByBuddyList.value[buddyList.id];
            if (usernames) {
                for (let username of usernames) {
                    let client = this.getByUsername(username, false);
                    if (client) {
                        let unreaded = client.unreadedMessageIds.length;
                        if (unreaded) {
                            result[buddyList.id][username] = unreaded;
                        }
                    }
                }
            }
        }
        return result;
    });
    private subscribes = ref<Dictionary<Dictionary<ComponentInstance<any>[]>>>({});
    private cobrowseEnabled = ref<Dictionary<boolean>>({});
    private translateEnabled = ref<Dictionary<boolean>>({});

    public isFreeByUsername(username: string) {
        let userdata = this.getByUsername(username, false);
        if (userdata) {
            return this.isFreeByUserdata(userdata);
        }
        return false;
    }
    private clientsWithNewDalogs = ref<Dictionary<boolean>>({});
    private clientLastActivityTimestamp = ref<Dictionary<number>>({});

    CLEAR() {
        this.userdataDictionary.value = {};
        this.messagesDictionary.value = {};
        this.dialogsDictionary.value = {};
        this.dialogsIds.value = {};
        this.subscribes.value = {};
        this.siteOfUsernames.value = {};
        this.siteOfUsernamesNonReactive = {};
        this.subscribesByBuddyList.value = {};
        this.cobrowseEnabled.value = {};
        this.translateEnabled.value = {};
        this.clientsWithNewDalogs.value = {};
        this.clientLastActivityTimestamp.value = {};
        this.selectedUsernameInSelectedSection.value = null;
    }

    public disableDelayBeforeFetch() {
        this.isDelayBeforeFetch = false;
    }

    public setSelectedUsernameInSelectedSection(username: string) {
        this.selectedUsernameInSelectedSection.value = username;
    }

    public setClientWithNewDialog(username: string) {
        this.clientsWithNewDalogs.value[username] = true;
    }

    public unsetClientWithNewDialog(username: string) {
        delete this.clientsWithNewDalogs.value[username];
    }

    public setClientLastActivityTimestamp(username: string) {
        this.clientLastActivityTimestamp.value[username] = Math.ceil(Date.now() / 1000);
    }

    public unsetClientLastActivityTimestamp(username: string) {
        delete this.clientLastActivityTimestamp.value[username];
    }

    public getClientLastActivityTimestamp(username: string): number | null {
        return this.clientLastActivityTimestamp.value[username];
    }

    public isClientHasNewDialog(username: string): boolean {
        return !!this.clientsWithNewDalogs.value[username];
    }

    public isFreeByUserdata(userdata: OperatorApplicationApi.OperatorApplicationClientOpenApiModel) {
        let site = OperatorAccountStore.sitesDictionary.value[userdata.siteId];
        if (site) {
            return site.isFree;
        }

        return false;
    }

    public subscribe(username: string, buddyList: OperatorApplicationApi.OperatorBuddyListConfigOpenApiModel, instance: ComponentInstance<any>) {
        if (!this.subscribes.value[username]) {
            this.subscribes.value[username] = {};
        }
        if (!this.subscribes.value[username][buddyList.id]) {
            this.subscribes.value[username][buddyList.id] = [];
        }
        if (!this.subscribesByBuddyList.value[buddyList.id]) {
            this.subscribesByBuddyList.value[buddyList.id] = [];
        }
        toggleArrayElement(this.subscribesByBuddyList.value[buddyList.id], username, true);
        toggleArrayElement(this.subscribes.value[username][buddyList.id], instance, true);
    }

    public unsubscribe(username: string, buddyList: OperatorApplicationApi.OperatorBuddyListConfigOpenApiModel, instance: ComponentInstance<any>) {
        if (this.subscribes.value[username] && this.subscribes.value[username][buddyList.id]) {
            toggleArrayElement(this.subscribes.value[username][buddyList.id], instance, false);

            setTimeout(() => {
                let subscribes = this.subscribes.value[username];
                if (subscribes) {

                    let keep = false;
                    for (let buddyListId in subscribes) {
                        if (subscribes.hasOwnProperty(buddyListId)) {
                            if (subscribes[buddyListId].length) {
                                keep = true;
                            } else {
                                toggleArrayElement(this.subscribesByBuddyList.value[buddyList.id], username, false);
                            }
                        }
                    }

                    if (!keep) {
                        delete this.subscribes.value[username];
                        delete this.userdataDictionary.value[username];
                        delete this.messagesDictionary.value[username];
                        delete this.dialogsDictionary.value[username];
                        delete this.siteOfUsernames.value[username];
                        delete this.siteOfUsernamesNonReactive[username];
                        delete this.cobrowseEnabled.value[username];
                        delete this.translateEnabled.value[username];
                    }
                }
            }, 1000);
        }
    }

    public SET_COBROWSE_ENABLED(payload: { username: string, value: boolean }) {
        this.cobrowseEnabled.value[payload.username] = payload.value;
    }

    isCobrowseEnabled(username: string) {
        if (typeof this.cobrowseEnabled.value[username] == "undefined") {
            this.SET_COBROWSE_ENABLED({username, value: false})
        }
        return this.cobrowseEnabled.value[username];
    }

    public SET_TRANSLATE_ENABLED(payload: { username: string, value: boolean }) {
        this.translateEnabled.value[payload.username] = payload.value;
    }

    isTranslateEnabled(username: string) {
        if (typeof this.translateEnabled.value[username] == "undefined") {
            this.SET_TRANSLATE_ENABLED({username, value: false})
        }
        return this.translateEnabled.value[username];
    }

    getUnreadedCountByBuddyList(buddyListId: string): number | string {
        let result = 0;
        let list = this.unreadedCountByBuddyList.value[buddyListId];
        let buddyList = OperatorAccountStore.buddyListConfigDictionary.value[buddyListId];
        if (list) {
            for (let username in list) {
                if (list.hasOwnProperty(username)) {
                    if (buddyList.isCrossOperatorsChat) {
                        let userdata = this.getByUsername(username, false);
                        if (userdata.unreadedMentionMessageIds.length) {
                            return "@";
                        }
                    }
                    if (OperatorApplicationConfigInstance.buddyListBadgeType == APP_ICON_BADGE_TYPE_MESSAGES) {
                        result += list[username];
                    } else {
                        result++;
                    }
                    //result += list[username];
                }
            }
        }
        return result;
    }

    clear() {
        this.CLEAR();
    }

    SET(client: CometOperatorApplication.OperatorApplicationClientOpenApiModel) {
        if (OperatorAccountStore.isAuthorized.value) {
            let prevUserdata = this.userdataDictionary.value[client.username];
            let hashMismatch = !prevUserdata || client.hash != prevUserdata.hash;

            if (client.unreadedMessageIds.length) {
                let messages = this.messagesDictionary.value[client.username];
                if (messages) {
                    for (let i = messages.length - 1; i >= 0; i--) {
                        let message = messages[i];
                        if (message.isSendByClient && message.statusId == "readed") {
                            client.unreadedMessageIds = client.unreadedMessageIds.filter(id => id > message.id);
                            client.unreadedMentionMessageIds = client.unreadedMentionMessageIds.filter(id => id > message.id);
                            break;
                        }
                    }
                }
            }

            if (!client.unreadedMessageIds.length && !client.messagesWithUnreadedState.length) {
                OperatorApplicationPlatform.notifications.closeByGroupId(client.username);
            }


            this.siteOfUsernames.value[client.username] = this.siteOfUsernamesNonReactive[client.username] = client.type.isCrossOperatorsChat ? null : client.siteId;

            if (hashMismatch) {
                if (client.type.isCrossOperatorsChat) {
                    let chat = OperatorAccountStore.crossOperatorChat.value[client.username];
                    if (chat) {
                        client.displayDescr = chat.descr;
                        let avatar = chat.avatar;
                        let clientAvatar = {
                            ...client.avatar
                        };
                        if (avatar) {
                            client.avatar.url = avatar;
                            client.avatar.isReal = true;
                        }
                        Object.defineProperty(client, "displayDescr", {
                            get(): string {
                                return OperatorAccountStore.crossOperatorChat.value[client.username]?.descr ?? chat.descr;
                            },
                            set(v: string) {

                            }
                        });
                        Object.defineProperty(client, "avatar", {
                            get(): OperatorApplicationClientAvatarOpenApiModel {
                                let result: OperatorApplicationClientAvatarOpenApiModel = {
                                    ...clientAvatar
                                };
                                let chat = OperatorAccountStore.crossOperatorChat.value[client.username];
                                let avatar = chat?.avatar;
                                if (avatar) {
                                    result.url = avatar;
                                    result.isReal = true;
                                }
                                return result;
                            },
                            set(v: OperatorApplicationClientAvatarOpenApiModel) {

                            }
                        })

                        client.status = chat.statusGetter();

                    }
                }
                if (client.isHaveNoAnswer) {
                    if (!prevUserdata || !prevUserdata.isHaveNoAnswer) {
                        OperatorApplicationEventManager.emit(NEW_HAVE_NO_ANSWER_CLIENT, client);
                    }
                }
                if (!prevUserdata) {
                    this.userdataDictionary.value[client.username] = client;
                } else {
                    for (let key in client) {
                        if (client.hasOwnProperty(key)) {
                            let newValue = (client as any)[key];
                            let prevValue = (prevUserdata as any)[key];
                            if (newValue !== prevValue) {
                                if (JSON.stringify(newValue) !== JSON.stringify(prevValue)) {
                                    (prevUserdata as any)[key] = newValue;
                                }
                            }
                        }
                    }
                }
            }

            this.modifyUnreadedMessageIds(client.username);
            if (hashMismatch) {
                this.updateClientOrder(client.username);
            }
        }
    }

    updateClient(update: () => OperatorApplicationClientOpenApiModel) {
        this.updateClientOrder(update().username);
    }

    updateClientOrder(username: string) {
        OperatorApplicationEventManager.emit(UPDATE_ORDER, username);
    }

    set(client: CometOperatorApplication.OperatorApplicationClientOpenApiModel) {
        this.SET(client);
    }

    readMessages(payload: { username: string }) {
        OperatorApplicationEventManager.emit(READ_ALL_MESSAGES_OF_CLIENT, payload.username);
    }

    UPDATE_UNREADED_MESSAGE_ID_LIST(payload: {
        username: string,
        messageIds: number[],
        adminMessageIds: number[],
        mentionMessageIds: number[],
        crossOperatorConversationUnreadMessageCount: number
    }) {
        let userdata = this.userdataDictionary.value[payload.username];
        if (!payload.messageIds.length) {
            if (this.markedAsUnreadedDictionary.value[payload.username]) {
                delete this.markedAsUnreadedDictionary.value[payload.username];
            }
        }
        if (userdata) {
            userdata.unreadedMessageIds = payload.messageIds;
            userdata.unreadedAdminMessageIds = payload.adminMessageIds;
            userdata.unreadedMentionMessageIds = payload.mentionMessageIds;
            userdata.crossOperatorConversationUnreadMessageCount = payload.crossOperatorConversationUnreadMessageCount;
            this.SET(userdata);
        }
    }

    markAsUnreaded(username: string) {
        this.markedAsUnreadedDictionary.value[username] = true;
        this.modifyUnreadedMessageIds(username);
    }

    hasClientByUsername(username: string): boolean {
        return !!this.userdataDictionary.value[username];
    }

    getByUsername(username: string, fetchIfNotExist: boolean = true, forceFetch: boolean = false): CometOperatorApplication.OperatorApplicationClientOpenApiModel | null {
        if (username) {
            let userdata = this.userdataDictionary.value[username];
            if (!userdata) {
                this.userdataDictionary.value[username] = userdata = null;
            }
            if (!userdata || forceFetch) {
                if (fetchIfNotExist) {
                    this.fetchAndSetUserdata(username);
                    return this.userdataDictionary.value[username];
                }
            }
            return userdata;
        } else {
            return null;
        }
    }

    getUnreadedStateListByUserdata(userdata: OperatorApplicationClientOpenApiModel): UnreadedMessageStateInterface[] {
        let result: Dictionary<UnreadedMessageStateInterface> = {};
        for (let item of userdata.messagesWithUnreadedState) {
            if (!result[item.typeId]) {
                let state: UnreadedMessageStateInterface;
                if (item.isReaction) {
                    state = {
                        icon: 'heart',
                        messageIds: []
                    };
                } else if (item.isEdit) {
                    state = {
                        icon: 'pencil',
                        messageIds: []
                    };
                }
                result[item.typeId] = state;
            }
            if (result[item.typeId]) {
                result[item.typeId].messageIds.push(item.messageId);
            }
        }
        return ObjectHelper.arrayFromDictionary(result);
    }

    getUnreadedReactionByUserdata(userdata: OperatorApplicationClientOpenApiModel): ClientMessageWithUnreadedStateOpenApiModel[] {
        let result: ClientMessageWithUnreadedStateOpenApiModel[] = [];
        if (userdata.messagesWithUnreadedState.length) {
            result = userdata.messagesWithUnreadedState.filter(item => item.isReaction);
        }
        return result;
    }

    getUnreadedEditByUserdata(userdata: OperatorApplicationClientOpenApiModel): ClientMessageWithUnreadedStateOpenApiModel[] {
        let result: ClientMessageWithUnreadedStateOpenApiModel[] = [];
        if (userdata.messagesWithUnreadedState.length) {
            result = userdata.messagesWithUnreadedState.filter(item => item.isEdit);
        }
        return result;
    }

    async getByUsernameAsync(username: string) {
        let client = this.getByUsername(username, false);
        if (!client) {
            client = await this.fetchAndSetUserdata(username);
        }
        return client;
    }

    public async fetchAndSetUserdata(username: string) {
        let userdata = await this.fetchUserdata(username);
        if (userdata) {
            this.SET(userdata);
            return userdata;
        }
        return null;
    }


    getMessagesByUsername(username: string) {
        if (!this.messagesDictionary.value[username]) {
            this.messagesDictionary.value[username] = [];
        }
        return this.messagesDictionary.value[username];
    }

    getDialogsByUsername(username: string) {
        if (!this.dialogsDictionary.value[username]) {
            this.dialogsDictionary.value[username] = {};
        }
        return this.dialogsDictionary.value[username];
    }

    getDialogsIdsByUsername(username: string) {
        if (!this.dialogsIds.value[username]) {
            this.dialogsIds.value[username] = [];
        }
        return this.dialogsIds.value[username];
    }

    removeMessage(payload: { username: string, messageId: number }) {
        let messages = this.getMessagesByUsername(payload.username);
        for (let i = 0; i < messages.length; i++) {
            if (messages[i].id == payload.messageId) {
                messages.splice(i, 1);
                break;
            }
        }
        OperatorApplicationEventManager.emit(MESSAGE_REMOVED, payload.messageId);
    }

    addMessage(payload: { message: CometOperatorApplication.OperatorApplicationMessageOpenApiModel, replaceOnly?: boolean }) {
        let message = payload.message;
        let username = message.username;
        if (this.hasClientByUsername(username)) {
            let needSort = false;
            let messages = this.getMessagesByUsername(username);
            let index = messages.findIndex(
                item => {
                    return (item.id && item.id == message.id)
                        ||
                        (!item.id && typeof message.temporaryId == "string" && message.temporaryId === item.temporaryId)
                        ||
                        //Это случай с редактированием
                        (message.id && item.temporaryId && message.id.toString() === item.temporaryId.toString())
                }
            );
            let changed = false;
            if (index > -1) {
                if (message.id) {
                    let prevMessageVersion = messages[index];
                    if (!prevMessageVersion.id) {
                        let messageBefore = messages[index - 1];
                        let messageAfter = messages[index + 1];
                        needSort = !!(
                            (messageBefore && messageBefore.id && messageBefore.id > message.id)
                            ||
                            (messageAfter && messageAfter.id && messageAfter.id < message.id)
                        );
                    }
                }
                if (message.id || !messages[index].id) {
                    for (let key in message) {
                        if (message.hasOwnProperty(key)) {
                            (messages[index] as any)[key] = (message as any)[key];
                        }
                    }
                    changed = true;
                }
            } else if (!payload.replaceOnly) {
                let lastMessage = messages[messages.length - 1];
                needSort = !!(message.id && lastMessage && lastMessage.id > message.id);
                messages.push(message);
                changed = true;
            }
            if (changed) {
                OperatorApplicationEventManager.emit(SCROLL_CHAT_TO_BOTTOM, username);
            }
            if (needSort) {
                messages.sort((a, b) => {
                    if (a.id < 1 || b.id < 1) {
                        if (a.dateTime == b.dateTime) {
                            return 0;
                        } else {
                            return a.dateTime < b.dateTime ? -1 : 1;
                        }
                    }
                    return a.id < b.id ? -1 : 1;
                });
            }
        }
    }

    updateMessageStatus(payload: { messageId: number, username: string, statusId: string }) {
        let messages = this.getMessagesByUsername(payload.username);
        for (let i = messages.length - 1; i >= 0; i--) {
            let message = messages[i];
            if (!message.hasSeparateStatus || payload.messageId == message.id) {
                if (!message.isSendByClient && (!message.messageType || message.messageType.isVisibleForClient)) {
                    if (message.id <= payload.messageId) {
                        if (message.statusId != payload.statusId && (!message.statusId || message.statusId == MESSAGE_STATUS_DELIVERED)) {
                            message.statusId = payload.statusId as any;
                        } else {
                            break;
                        }
                    }
                }
                if (message.hasSeparateStatus && payload.messageId == message.id) {
                    break;
                }
            }
        }
    }

    public async reload() {
        if (!OperatorAccountStore.isCabinetIframe) {
            for (let username in this.userdataDictionary.value) {
                if (this.userdataDictionary.value.hasOwnProperty(username)) {
                    this.getByUsername(username, true, true);
                }
            }
            this.dialogsDictionary.value = {};
            this.dialogsIds.value = {};
            for (let username in this.messagesDictionary.value) {
                if (this.messagesDictionary.value.hasOwnProperty(username)) {
                    let messages = this.messagesDictionary.value[username];
                    if (messages.length > 0) {
                        messages.splice(0, messages.length);
                    }
                }
            }
        }
    }

    private fetchQueue: string[] = [];

    private async fetchUserdata(username: string): Promise<CometOperatorApplication.OperatorApplicationClientOpenApiModel | null> {
        if (this.fetchQueue.indexOf(username) === -1) {
            this.fetchQueue.push(username);
        }
        this.fetch();
        return await new Promise(resolve => {
            fetchEvents.once(username, data => {
                resolve(data);
            });
        });
    }

    private modifyUnreadedMessageIds(username: string) {
        let userdata = this.userdataDictionary.value[username];
        if (userdata) {
            if (this.markedAsUnreadedDictionary.value[username]) {

                if (!userdata.unreadedMessageIds.length) {
                    userdata.unreadedMessageIds.push(-1);
                }
            }
            if (!userdata.unreadedMessageIds.length) {
                this.unsetClientWithNewDialog(username);
            }
        }
    }

    private SET_LOADING(value: boolean) {
        this.isLoading.value = value;
    }

    private isAuthorized() {
        let result = OperatorAccountStore.isAuthorized.value;
        if (!result) {
            this.fetchQueue = [];
        }
        return result;
    }

    private async fetch() {
        if (this.fetchQueue.length) {
            if (this.isAuthorized()) {
                try {
                    if (this.fetchQueue.length >= FETCH_LIMIT) {
                        Delay.override("fetchUserdata");
                    } else {
                        await Delay.make(this.isDelayBeforeFetch ? 100 : 1, "fetchUserdata");
                    }
                    if (!this.isLoading.value) {
                        this.SET_LOADING(true);
                        while (true) {
                            if (this.isAuthorized()) {
                                let usernames = this.fetchQueue.slice(0, FETCH_LIMIT);
                                if (usernames.length) {
                                    let clients: OperatorApplicationApi.OperatorApplicationClientOpenApiModel[] = [];
                                    let sameHashes: string[] = [];
                                    let knownHashes: string[] = [];
                                    let userdataByHash: Dictionary<OperatorApplicationApi.OperatorApplicationClientOpenApiModel> = {};
                                    for (let username of usernames) {
                                        let userdata = this.userdataDictionary.value[username];
                                        if (userdata && userdata.hash) {
                                            knownHashes.push(userdata.hash);
                                            userdataByHash[userdata.hash] = userdata;
                                        }
                                    }
                                    try {
                                        let p: OperatorApplicationApi.OperatorGetUserdataOpenApiModel = {
                                            usernames,
                                            knownHashes
                                        };
                                        let data = (await (new OperatorApiRequest<OperatorApplicationApi.OperatorGetUserdataResultOpenApiModel>({
                                            url: "/buddyList/getUserdata",
                                            p,
                                            silent: !OperatorAccountStore.cabinetClientDialog.value,
                                            silentError: true
                                        })).send()).data;
                                        if (data) {
                                            clients = data.clients;
                                            sameHashes = data.sameHashes;
                                        }
                                    } catch (e) {
                                        console.error("Не удалось получить данные клиентов", e);
                                    }
                                    let count = usernames.length;

                                    for (let hash of sameHashes) {
                                        let client = userdataByHash[hash];
                                        if (client) {
                                            clients.push(client);
                                        }
                                    }

                                    for (let client of clients) {
                                        toggleArrayElement(usernames, client.username, false);
                                        fetchEvents.emit(client.username, client);
                                    }

                                    for (let username of usernames) {
                                        fetchEvents.emit(username, null);
                                    }
                                    this.fetchQueue.splice(0, count);
                                    continue;
                                }
                            }
                            break;
                        }
                        this.SET_LOADING(false);
                    }

                } catch (e) {

                }
            }
        }
    }

}


export const ClientUserdataStore = new ClientUserdata();

OperatorApplicationEventManager.addEventListener(OPERATOR_APPLICATION_RELOAD_DATA_EVENT, () => {
    ClientUserdataStore.reload();
});

OperatorApplicationEventManager.addEventListener(OPERATOR_STATUS_UPDATED, (payload: OperatorStatusUpdatedEventPayload) => {
    if (!OperatorAccountStore.isCabinetIframe) {
        let operator = payload.operator;
        let chatId = operator.chatId;
        if (chatId) {
            let userdata = ClientUserdataStore.getByUsername(chatId);
            if (userdata) {
                userdata.status = OperatorAccountStore.getCrossOperatorsChatClientStatusByOperator(operator);
            }
        }
    }
});


interface UnreadedMessageStateInterface {
    icon: string;
    messageIds: number[];
}
